module.exports = __webpack_public_path__ + "img/painter_house.48ddfb04.png";